const initCardListTextCta = () => {
    const config = new CarouselConfig();
    config.sliderSelector = "[data-card-list-slider]";
    config.cellAlign = CellAlign.left;
    config.contain = true;
    config.autoPlay = false;
    config.wrapAround = false;
    config.showArrows = true;
    config.showArrows = true;
    config.showDots = true;
    config.groupCells = true;
    config.adaptiveHeight = false;
    config.imagesLoaded = false;
    const responsiveCarousel = new ResponsiveCarousel();
    responsiveCarousel.initCarousel(config);
};
